import Main from 'pages/main';
import './app.scss';
import AprilFoolsJory from 'components/AprilFoolsJory';
import MyTowerModal from 'components/MyTowerModal';

const App = () => (
  <div>
    <MyTowerModal />
    <AprilFoolsJory>
      <Main />
    </AprilFoolsJory>
  </div>
);

export default App;
